
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SystemAttributes } from '../../modal/attributes.model';
import { formatDate } from '../../../../../../util';
import { KanbanState } from '../../../../kanban.model';
import ActivityStore from '../../../../../../stores/ActivityStore';
import Spinner from '../../../../../util/Spinner';
import { Board } from '../../../../../backend/backendapi';
import { isBoardNotInSelectedAccount } from '../../../../kanban.util';

@Component({
  components: { Spinner },
})
export default class ActivityAttribute extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
  @Prop({ required: true })
  readonly board!: Board;
  @Prop({ required: true })
  readonly attributes!: SystemAttributes;

  readonly store = new ActivityStore();

  get activity(): string {
    return this.activitiesForVSelect.find(e => e.id === this.attributes.activityId)?.name ?? '';
  }

  get activitiesForVSelect(): { id: number, name: string }[] {
    return this.store.activities.map(e => ({
      id: e.id!,
      name: (e.title ?? '') + ' (' + formatDate(e.currentDate!) + ', ' + this.$t('kanbanCardCell') + ': ' + e.cellName + ')',
    }));
  }

  get isBoardNotInSelectedAccount(): boolean {
    return isBoardNotInSelectedAccount(this.board, this.state.accounts);
  }

  mounted(): void {
    this.store.loadIfAbsent();
  }

  @Watch('state.accounts')
  private onAccountChanged(): void {
    this.store.reload();
  }
}
